module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon-test-dark.129b1746.svg";